/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author       Afternet <info@afternet.gr>
 *  @copyright Afternet
 *  @license      http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export default function megaMenu(){

    if( $('.js-mega-menu').length ){

        $('.js-mega-menu, .js-megaMenu').hover(function (){
            $('.js-megaMenu').addClass('opened');
        }, function (){
            $('.js-megaMenu').removeClass('opened');
        });

        const _menuFirstLvl = $('.js-mega-menu').find('.sub-menu').html();
        $('.js-megamenu-lvl1').html(_menuFirstLvl);

        const _menuFirstLvl_items = $('.js-megamenu-lvl1').children();
        _menuFirstLvl_items.hover(function (){

            if( $(this).hasClass('menu-item-has-children') ){

                $(this).find('a').first().css({'cursor' : 'default'});
                $(this).find('a').on('click', function (e){ e.preventDefault(); });

                const _title = $(this).find('a').first().text();
                const _description = $(this).find('.menu-description').first().text();
                const _submenu = $(this).find('.sub-menu').html();
                $('.js-megamenu-title').html(_title);
                $('.js-megamenu-text').html(_description);
                $('.js-megamenu-list').html(_submenu);

            }
        });

        const _firstSubMenuItem = $('.js-megamenu-lvl1').find('.menu-item-has-children').first();
        if( _firstSubMenuItem.length ){
            _firstSubMenuItem.find('a').first().css({'cursor' : 'default'});
            _firstSubMenuItem.find('a').on('click', function (e){ e.preventDefault(); });

            const _title = _firstSubMenuItem.find('a').first().text();
            const _description = _firstSubMenuItem.find('.menu-description').first().text();
            const _submenu = _firstSubMenuItem.find('.sub-menu').html();
            $('.js-megamenu-title').html(_title);
            $('.js-megamenu-text').html(_description);
            $('.js-megamenu-list').html(_submenu);
        }


    }
}
